import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CVNavigation() {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['general', 'education', 'skills', 'industry', 'research', 'projects', 'achievements', 'volunteering'];
      const scrollPosition = window.scrollY + 100;

      const currentSection = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return scrollPosition >= rect.top + window.scrollY && 
                 scrollPosition < rect.bottom + window.scrollY;
        }
        return false;
      });
      
      setActiveSection(currentSection || '');
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); 
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    const headerHeight = 90;
    
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  return (
    <nav className="section-nav">
      <ul>
        <li>
          <button 
            className={`nav-link ${activeSection === 'general' ? 'active' : ''}`}
            onClick={() => handleClick('general')}
          >
            GENERAL INFORMATION
          </button>
        </li>
        <li>
          <button 
            className={`nav-link ${activeSection === 'education' ? 'active' : ''}`}
            onClick={() => handleClick('education')}
          >
            EDUCATION
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'skills' ? 'active' : ''}`}
            onClick={() => handleClick('skills')}
          >
            SKILLS
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'industry' ? 'active' : ''}`}
            onClick={() => handleClick('industry')}
          >
            INDUSTRY EXPERIENCE
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'research' ? 'active' : ''}`}
            onClick={() => handleClick('research')}
          >
            RESEARCH EXPERIENCE
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`}
            onClick={() => handleClick('projects')}
          >
            PROJECTS
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'achievements' ? 'active' : ''}`}
            onClick={() => handleClick('achievements')}
          >
            ACHIEVEMENTS
          </button>
        </li>
        <li>
          <button
            className={`nav-link ${activeSection === 'volunteering' ? 'active' : ''}`}
            onClick={() => handleClick('volunteering')}
          >
            VOLUNTEERING
          </button>
        </li>
        <li>
          <Link to="/" className="nav-link">
            BACK
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default CVNavigation; 